import { useLanguage } from '@/components/utils/useLanguage';

export default function ActivityDiscountCards({ activity, discountCards = [] }) {
  const { language, t } = useLanguage();

  if (!(activity.discount_card_ids || []).length) return null;

  const cards = discountCards.filter(c => (activity.discount_card_ids || []).includes(c.id));
  if (!cards.length) return null;

  return (
    <div className="rounded-2xl border border-gray-100 bg-gradient-to-br from-gray-50 to-white p-4 my-8">
      <h3 className="font-bold text-gray-900 mb-3 text-sm">{t('Rabattkarten akzeptiert', 'Discount cards accepted')}</h3>
      <div className="flex flex-wrap gap-4">
        {cards.map(card => (
          <div key={card.id} className="flex flex-col items-center gap-2">
            {card.image
              ? <img src={card.image} alt={card.name} className="w-20 h-12 object-cover rounded-lg shadow-md" style={{transform:'rotate(-3deg)',boxShadow:'0 4px 12px rgba(0,0,0,0.15)'}} />
              : <div className="w-20 h-12 rounded-lg flex items-center justify-center text-white text-xs font-bold shadow-md" style={{background: card.color || '#374151', transform:'rotate(-3deg)',boxShadow:'0 4px 12px rgba(0,0,0,0.15)'}}>{card.name}</div>
            }
            <span className="text-xs font-medium text-gray-700">{card.name}</span>
            {(language === 'en' ? card.description_en || card.description_de : card.description_de) && (
              <p className="text-xs text-gray-500 text-center">{language === 'en' ? card.description_en || card.description_de : card.description_de}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}